export const authSliceKey = "auth";

export type AuthState = {
    token: string | null;
};

export const INITIAL_AUTH_STATE: AuthState = {
    token: null
};
